import { relativeResponseSchema } from 'app/src/msw/moneytransfer/schemas/relativeResponse'
import { transferStatusSchema } from 'app/src/msw/moneytransfer/schemas/transferStatus'
import type { TransferResponse, TransferResponseWithUserInfo } from 'app/src/services/welfareportal/moneytransfer-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

const transferResponseBaseSchema = z.object({
  id: z.string(),
  detailUrl: z.string().optional(),
  date: z.string().datetime(),
  productName: z.string(),
  productCode: z.string(),
  beneficiaryId: z.string(),
  kind: z.enum(['FONDO_SANITARIO', 'PREVIDENZA_COMPLEMENTARE']),
  status: transferStatusSchema,
  amount: z.number().optional(),
  familyMembers: z.array(relativeResponseSchema).optional(),
  orderId: z.string().optional(),
  isCancellable: z.boolean(),
})

const transferResponseUserInfoSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  fiscalCode: z.string().optional(),
  membershipId: z.string().optional(),
  userId: z.string().optional(),
})

export const transferResponseSchema: z.ZodType<TransferResponse> = transferResponseBaseSchema

export const transferResponseWithUserInfoSchema: z.ZodType<TransferResponseWithUserInfo> = transferResponseBaseSchema.extend({
  userInfo: transferResponseUserInfoSchema,
})
